//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.UploadFileMutation
import kotlin.String
import kotlin.collections.List

public object UploadFileMutation_ResponseAdapter {
  public object Data : Adapter<UploadFileMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("uploadFile")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): UploadFileMutation.Data {
      var _uploadFile: UploadFileMutation.UploadFile? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _uploadFile = UploadFile.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return UploadFileMutation.Data(
        uploadFile = _uploadFile ?: missingField(reader, "uploadFile")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: UploadFileMutation.Data,
    ) {
      writer.name("uploadFile")
      UploadFile.obj().toJson(writer, customScalarAdapters, value.uploadFile)
    }
  }

  public object UploadFile : Adapter<UploadFileMutation.UploadFile> {
    public val RESPONSE_NAMES: List<String> = listOf("fileName")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): UploadFileMutation.UploadFile {
      var _fileName: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _fileName = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return UploadFileMutation.UploadFile(
        fileName = _fileName ?: missingField(reader, "fileName")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: UploadFileMutation.UploadFile,
    ) {
      writer.name("fileName")
      StringAdapter.toJson(writer, customScalarAdapters, value.fileName)
    }
  }
}
